import Navbar from "./components/NavBar";
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import Goals from "./components/Goals";
import OurFields from "./components/OurFields";
import Partners from "./components/Partners";
import Projects from "./components/Projects";
import News from "./components/News";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <AboutUs />
      <Goals />
      <OurFields />
      <Partners />
      <Projects />
      <News />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default App;
